import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../shared/services/auth.service";
import { CookieService } from "ngx-cookie-service";
const Swal = require("sweetalert2");

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public newUser = false;
  public loginForm: FormGroup;
  public show: boolean = false;
  public errorMessage: any;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private authService: AuthService,
    private cookieService: CookieService
  ) {
    this.loginForm = this.fb.group({
      usuario: ["", [Validators.required]],
      senha: ["", Validators.required],
      lembrar: [false],
    });
  }

  ngOnInit() {}

  login() {
    if (!this.loginForm.valid) return;
    const { usuario, senha, lembrar } = this.loginForm.value;

    this.authService.login(usuario, senha).subscribe({
      next: (res) => {
        if (res.in_representante === false || res.in_representante === 0) {
          this.showAlert("error", "Você não é um representante.");
          return;
        }
        // Salvar dados do usuário no localStorage
        const userData = {
          nome: res.nome || "Usuário",
          token: res.token || "",
          id: res.id || 0,
          img: res.img || "",
          empresa_id: res.empresa_id || 0,
        };

        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("token", userData.token);

        this.router.navigate(["/dashboard/default"]);
      },
      error: (err) => {
        this.showAlert("error", "Usuário ou senha inválidos.");
      },
    });
  }

  showPassword() {
    this.show = !this.show;
  }

  showAlert(
    icon: "success" | "info" | "error",
    title: string,
    description?: string
  ) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: icon,
      title: title,
      text: description,
    });
  }
}
